import { Controller } from 'stimulus'

// Shows links to matching products under the navigation search field.
// Enter in the field submits the form, which opens the full product list.
export default class extends Controller {
  static targets = ['input', 'results']
  static values = { url: String }

  disconnect() {
    clearTimeout(this.searchTimer);
  }

  search() {
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => this.load(), 300);
  }

  async load() {
    const term = this.inputTarget.value.trim();
    this.request?.abort();
    if (term === '') return this.close();

    this.request = new AbortController();
    try {
      const response = await fetch(`${this.urlValue}?term=${encodeURIComponent(term)}`, {
        signal: this.request.signal,
        headers: { Accept: 'text/html' }
      });
      if (!response.ok) return this.close();

      this.resultsTarget.innerHTML = await response.text();
      this.resultsTarget.hidden = false;
    } catch (error) {
      if (error.name !== 'AbortError') throw error;
    }
  }

  close() {
    this.resultsTarget.hidden = true;
    this.resultsTarget.innerHTML = '';
  }

  closeOutside(event) {
    if (!this.element.contains(event.target)) this.close();
  }

  next(event) {
    this.moveFocus(event, 1);
  }

  previous(event) {
    this.moveFocus(event, -1);
  }

  // Arrow keys move the focus between the field and the result links.
  moveFocus(event, step) {
    const links = [...this.resultsTarget.querySelectorAll('a')];
    if (this.resultsTarget.hidden || links.length === 0) return;

    event.preventDefault();
    const items = [this.inputTarget, ...links];
    const index = items.indexOf(document.activeElement);
    items[Math.min(Math.max(index + step, 0), items.length - 1)].focus();
  }
}
